import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Tooltip, Link, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const CALCULATION_GUIDE_BAYESIAN = '/calculation-guide#bayesian';
export const METHODS_GUIDE_URL = '/methods-guide';
export const METHODS_GUIDE_BAYESIAN = '/methods-guide#bayesian';

const guideTooltip = (text) => (
  <Box sx={{ maxWidth: 260 }}>
    {text}{' '}
    <Link component={RouterLink} to={CALCULATION_GUIDE_BAYESIAN} color="inherit" underline="always">
      Metrik Rehberi
    </Link>
  </Box>
);

/** Signif. column header with guide tooltip */
export const SignificanceHeader = () => (
  <Tooltip
    arrow
    title={guideTooltip('Bayesian Monte Carlo simülasyonu ile hesaplanan kazanma olasılığı.')}
  >
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'help' }}
    >
      Signif.
      <HelpOutlineIcon sx={{ fontSize: 14, opacity: 0.65 }} />
    </Box>
  </Tooltip>
);

/** Significance value cell with tooltip + guide link */
export const SignificanceCell = ({ value }) => (
  <Tooltip
    arrow
    title={guideTooltip(`%${value} kazanma olasılığı. Detaylı açıklama için`)}
  >
    <span className="significance-cell">{value}%</span>
  </Tooltip>
);
